import Vue from "vue";
import SvgIcon from "@/components/svgicon";

// icons auto loaded
const req = require.context("./svg", false, /\.svg$/);
req.keys().map(req);

// register svg-icon globally
Vue.component("svg-icon", SvgIcon);
